<template>
  <div class="sso-btn" @click="ssoButtonClicked">
    <v-img contain :src="imageSrc" />
    <p>{{ buttonText }}</p>
  </div>
</template>

<script>
  export default {
    name: 'SsoButton',
    props: {
      buttonText: {
        required: true,
        default: '',
        type: String,
      },
      imageUrl: {
        required: true,
        default: '',
        type: String,
      },
    },
    data() {
      return {
        imageSrc: null,
      };
    },
    created() {
      this.loadImage();
    },
    methods: {
      ssoButtonClicked() {
        this.$emit('ssoButtonClicked');
      },
      loadImage() {
        this.imageSrc = require(`@/assets/shared/${this.imageUrl}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sso-btn {
    width: 100%;
  }
</style>
